import React, { useEffect, useState, useRef } from 'react';
import { ApiCore } from '../../api';
import styles from './laborAgreement.module.scss';
import SignContainer from '../../component/sign/signContainer.jsx';
import { Toast } from 'antd-mobile';
import utils from '../../utils/utils';
import OSS from "ali-oss";

const api = new ApiCore();

function LaborAgreement(props: any) {

    const [ossData, setOssData] = useState<any>({});// 获取OSS访问令牌

    // 协议内容
    const [renderContent, setRenderContent] = useState('');
    // 签名图片
    const [signImgUrl, setSignImgUrl] = useState('');
    const [imgHtml, setImgHtml] = useState('');

    // 签署状态Wait-待签署、Pass-已签署
    const [showSignBtn, setShowSignBtn] = useState(false);
    const [signState, setSignState] = useState('');
    // 重新签署
    const [showConfirmBtns, toShowConfirmBtns] = useState(false);
    const [subjectCode, setSubjectCode] = useState<any>();
    const mSignRef = useRef();

    useEffect(() => {
        document.title = '服务协议';
        initData();

    }, [props])

    useEffect(() => {
        getOssData()
    }, [])


    /**
     * 提取上传类型
     * @param {*} json 
     * @returns 
     */
    const filterPathPre = (json: any, type?: any) => {
        let newJson = json;
        let data: any = [];
        data = newJson.pathPre.split(',')
        data.map((i: any) => {
            if (i.includes(type)) {
                newJson.pathPre = i
            }
        })
        return newJson
    }

    /**
     * 获取OSS访问令牌
     */
    const getOssData = () => {
        api.GetCaseSts().then((res: any) => {
            if (res.code == 0) {
                if (!res.data) {
                    return
                }
                setOssData(res.data)
            } else {
                Toast.show({
                    content: res.message
                })
            }
        })
    };


    const uploadImage = (file: File): any => {
        return new Promise((resolve, reject) => {
            let client = new OSS({ ...filterPathPre(ossData, 'image') });
            let tenantCode = localStorage.getItem('tenantCode')
            let accountInf = localStorage.getItem('accountInf')
            let accounData = accountInf ? JSON.parse(accountInf) : {}

            //处理FileReader
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (e) => {
                const suffix = file.name.slice(file.name.lastIndexOf('.'));
                let time = new Date().getTime();
                const path = `${ossData.pathPre}${tenantCode}/${accounData.account}/${time}${suffix}`;
                // oss上传
                client.put(
                    path,
                    file,
                ).then((res: any) => {
                    resolve(res.url);
                }).catch((err: any) => {
                    console.log(err);
                    Toast.show('上传失败请重试');
                })

            }
        })
    }



    const initData = () => {
        let urlParam = utils.getUrlParams() || {};
        console.log(' urlParam_= ', urlParam);
        let subjectCode = urlParam.code;
        if (subjectCode) {
            setSubjectCode(subjectCode);
            preSign(subjectCode);
        }

        if (urlParam.signState == 'Wait') {
            setShowSignBtn(true)
        }
        if (urlParam.signState == 'Pass') {
            toShowConfirmBtns(true)
        }
        setSignState(urlParam.signState)
    }

    const preSign = (subjectCode: string) => {
        api.getSubjectAgreement({
            subjectCode
        }).then((res: any) => {
            if (res.code == 0) {
                if (!res.data || res.data == '' || res.data == null) {
                    return
                }
                let _data = res.data;
                setRenderContent(_data);
                const toContent = _data.replace('${sign}', '');
                innerHtmlRender(toContent);
            }
        });
    }

    const innerHtmlRender = (val: string) => {
        const _dom = document.getElementById('labor_service_articles_content');
        if (_dom) {
            _dom.innerHTML = val;
        }
    }


    const updateSignUrl = (imgUrl: any) => {
        setSignImgUrl(imgUrl);
        if (renderContent) {
            let imgHtml = `<img id= "sign_img" style="width: 100px; margin-bottom: -22px;" src="${imgUrl}" />`;
            setImgHtml(imgHtml);

            if (renderContent.includes('${sign}')) {
                let toContent = renderContent.replace('${sign}', imgHtml);
                innerHtmlRender(toContent);
            } else {
                const _img = document.getElementById('sign_img');
                if (_img) {
                    // @ts-ignore
                    _img.src = imgUrl
                }
            }
            toHideSignBtn();
            toShowConfirmBtns(true);
        }
    }

    const toHideSignBtn = () => {
        setShowSignBtn(false);
    }

    const toSign = () => {
        // @ts-ignore
        mSignRef.current && mSignRef.current.toShowModal();
    }

    const reSign = () => {
        // @ts-ignore
        mSignRef.current && mSignRef.current.toShowModal({
            resign: true
        });
    }

    const confirmSubmit = async () => {

        let file = utils.base64ToFile(signImgUrl, 'sign')

        let signUrl = await uploadImage(file)

        let methods = signState == 'Pass' ? api.subjectReSign : api.subjectSign
        methods({
            sign: `<img id= "sign_img" style="width: 100px; margin-bottom: -22px;" src="${signUrl}" />`,
            subjectCode
        }).then((oRes: any) => {
            if (oRes.code == 0) {
                Toast.success('签名成功');
                toHideSignBtn();
                toShowConfirmBtns(false);
                props.history.go(-1)
            } else {
                Toast.fail(oRes.message || '签名失败');
            }
        })
    }

    return (
        <div className={styles.laborAgreement_content}>
            <div className={styles.content_wrap} id='labor_service_articles_content'></div>
            <SignContainer ref={mSignRef} updateSignUrl={updateSignUrl} ></SignContainer>
            {
                showSignBtn &&
                <div className={styles.btn_bottom} onClick={toSign}>立即签名</div>
            }
            {
                showConfirmBtns &&
                <div className={styles.btns_confirm}>
                    <div className={styles.btn_cancel} onClick={reSign}>重新签名</div>
                    <div className={styles.btn_confirm} onClick={confirmSubmit}>确认并提交</div>
                </div>
            }
        </div>
    )
}

export default LaborAgreement;